import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'indianDecimal'
})
export class IndianDecimalPipe implements PipeTransform {
  transform(value: number | string, fractionDigits: number = 2, includeSymbol: boolean = true): string {
    if (value === null || value === undefined) return '';

    // Convert value to a string with specified fraction digits
    let [integer, fraction] = Number(value).toFixed(fractionDigits).split('.');

    // Add commas as per the Indian numbering system
    integer = integer.replace(/\B(?=(\d{2})+(\d{1})(?!\d))/g, ',');

    // Combine integer and fraction parts
    const formattedValue = fraction ? `${integer}.${fraction}` : integer;

    // Prepend ₹ symbol if includeSymbol is true
    return includeSymbol ? `₹ ${formattedValue}` : formattedValue;
  }
}
